/**
 * Shopify Theme Integration for DecoNetwork Customization
 *
 * Add this script to your Shopify theme's product page template
 * Location: theme.liquid or product-template.liquid
 *
 * INSTRUCTIONS:
 * 1. Add a "Customize This Product" button to your product page
 * 2. Include this script in your theme
 * 3. Configure the MIDDLEWARE_URL below
 */

(function() {
  'use strict';

  // Configuration
  const MIDDLEWARE_URL = 'https://blankandbranded-mw-335937677122.us-central1.run.app';

  /**
   * Initialize the customize button
   */
  function initCustomizeButton() {
    const customizeButton = document.querySelector('[data-customize-product]');

    if (!customizeButton) {
      console.warn('Customize button not found. Add data-customize-product attribute to your button.');
      return;
    }

    customizeButton.addEventListener('click', function(e) {
      e.preventDefault();
      handleCustomizeClick();
    });
  }

  /**
   * Handle customize button click
   */
  function handleCustomizeClick() {
    // Get the currently selected variant
    const variantId = getSelectedVariantId();
    const productHandle = getProductHandle();

    if (!variantId) {
      alert('Please select a size and color before customizing.');
      return;
    }

    if (!productHandle) {
      console.error('Product handle not found');
      alert('Unable to load customizer. Please refresh the page and try again.');
      return;
    }

    // Build the middleware URL
    const quantity = getSelectedQuantity();
    const customizeUrl = `${MIDDLEWARE_URL}/customize?product_handle=${encodeURIComponent(productHandle)}&variant_id=${encodeURIComponent(variantId)}&quantity=${quantity}`;


    console.log('Opening customizer:', customizeUrl);

    // Redirect to middleware, which will redirect to DecoNetwork
    window.location.href = customizeUrl;
  }

  /**
   * Get the currently selected variant ID
   */
  function getSelectedVariantId() {
    // Method 1: Check Shopify's variant selector (most common)
    const variantSelector = document.querySelector('select[name="id"]');
    if (variantSelector && variantSelector.value) {
      return variantSelector.value;
    }

    // Method 2: Check hidden input (used in some themes)
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) {
      return variantInput.value;
    }

    // Method 3: Check if variant is in the URL (rare)
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('variant');
    if (variantParam) {
      return variantParam;
    }

    // Method 4: Try to get from Shopify's theme object (if available)
    if (typeof theme !== 'undefined' && theme.product && theme.product.selected_variant) {
      return theme.product.selected_variant.id;
    }

    return null;
  }

  /**
   * Get the product handle from the page
   */
  function getProductHandle() {
    // Method 1: From meta tag (add this to your product template)
    const metaTag = document.querySelector('meta[name="product-handle"]');
    if (metaTag) {
      return metaTag.content;
    }

    // Method 2: Parse from URL (assumes URL is /products/HANDLE)
    const pathMatch = window.location.pathname.match(/\/products\/([^\/]+)/);
    if (pathMatch) {
      return pathMatch[1];
    }

    // Method 3: From data attribute on product form
    const productForm = document.querySelector('[data-product-handle]');
    if (productForm) {
      return productForm.dataset.productHandle;
    }

    return null;
  }

  function getSelectedQuantity() {
    const qtyInput = document.querySelector('input[name="quantity"]') ||
                    document.querySelector('[data-quantity-input]') ||
                    document.querySelector('.quantity__input');
    return qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomizeButton);
  } else {
    initCustomizeButton();
  }
})();
